import { render, staticRenderFns } from "./NavbarUI.vue?vue&type=template&id=318a55b0&scoped=true&"
import script from "./NavbarUI.vue?vue&type=script&lang=js&"
export * from "./NavbarUI.vue?vue&type=script&lang=js&"
import style0 from "./NavbarUI.vue?vue&type=style&index=0&id=318a55b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a55b0",
  null
  
)

export default component.exports